import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Carousel,
  DatePicker,
  Form,
  Image,
  Input,
  List,
  Modal,
  Popconfirm,
  Popover,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
  Upload,
} from "antd";
import axios from "axios";
import DoctorHeader from "../../../doctor/DoctorHeader";
import Sidebar from "../../Sidebar";
// import { morning_img_02 } from "../../../components/imagepath";
import useUser from "../../../hooks/useUser";
import "./Studies.css";
import { baseURl } from "../../../utils/urls";
import apiClient from "../../../utils/apiClient";
import UploadStudyModal from "./UploadStudyModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import timeline from "../../../assets/img/timeline.svg";
import feedback from "../../../assets/img/feedback.svg";
import feedbackicon from "../../../assets/img/feedbackicon.svg";
import excelicon from "../../../assets/img/excelicon.svg";
import remarkicon from "../../../assets/img/remarkicon.svg";
import remarkiconhover from "../../../assets/img/remarkiconhover.svg";
import moment from "moment/moment";
// import moment from "moment-timezone";
import {
  CheckCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FolderViewOutlined,
  LinkOutlined,
  RedoOutlined,
  ShareAltOutlined,
  UploadOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import StudyTextModal from "./StudyTextModal";
import FormItem from "antd/es/form/FormItem";
import RadioPrefrenceModal from "./RadioPrefrenceModal";
import AssignQualityChecker from "./AssignQualityChecker";
import useToast from "../../../hooks/userToast";
import { Link } from "react-router-dom";
import AssignGrade from "./AssignGrades";
import StudyFeedbackModal from "./StudyFeedbackModal";
import StudyRemarkModal from "./StudyRemarkModal";
import { useUnreadMessages } from "../../context/UnreadMessagesProvider";
import UpdateStudyDescription from "./UpdateStudyDescription";
import dayjs from "dayjs";
import { EditableCell } from "./EditableCell";
import { Edit, Refresh } from "@mui/icons-material";
import ManageStudyPreference from "./ManageStudyPreference";
import { socket } from "../../../utils/socket";

const { Option } = Select;
function Studies() {
  let carouselRef = null;
  const [StudyData, setStudyData] = useState([]);
  const [uploadModal, setUploadModal] = useState({ isModalOpen: false });
  const [textModal, setTextModal] = useState({ isModalOpen: false });
  // const [showModal, setShowModal] = useState(false);
  // const [iframeUrl, setIframeUrl] = useState("");
  // console.log("iframeUrl", iframeUrl, showModal);

  // const [editViewerRadioModal, setEditViewerRadioModal] = useState({
  //   isModalOpen: false,
  //   iframeUrl: "",
  // });
  const [copyUrl, setCopyUrl] = useState();
  const [categories, setCategories] = useState();
  const [attachModal, setAttachModal] = useState({
    isModalOpen: false,
    image: [],
  });

  const [previewModal, setPreviewModal] = useState({
    open: false,
    currentIndex: 0,
    files: [],
  });
  const [searchValues, setSearchValues] = useState();
  const [filterExist, setFilterExist] = useState(false);
  const currentPage = useRef(1);
  const limit = useRef(10);
  const [radioMetrics, setRadioMetrics] = useState([]);
  const [allRadioMetrics, setAllRadioMetrics] = useState([]);
  const [toggleStudies, setToggleStudies] = useState(false);
  const [RadioPrefModal, setRadioPrefenceModal] = useState({
    isModalOpen: false,
    type: "",
  });
  const [imageModal, setImageModal] = useState({
    isModalOpen: false,
    url: "",
  });
  // const navigate = useNavigate();
  // const handleOkViewerEditRadioModal = () => {
  //   // Handle Ok action if needed
  //   // setEditViewerRadioModal({ ...editRadioModal, isModalOpen: false });
  // };

  // const handleCancelViewerEditRadioModal = () => {
  //   // Close the modal without changes
  //   // setEditViewerRadioModal({ ...editRadioModal, isModalOpen: false });
  // };
  const [gradeModal, setGradeModal] = useState({
    radiologist: {},
    study_info_model_id: "",
    isModalOpen: false,
    status: "revise",
    grade: true,
  });
  const [qcModal, setQcModal] = useState({ isModalOpen: false });
  const [editDescModal, setEditDescModal] = useState({ isModalOpen: false });
  const [editRadioModal, setEditRadioModal] = useState({ isModalOpen: false });
  const [siteData, SetSiteData] = useState();
  const [currentStudyID, setCurrentStudyID] = useState();
  const [studyPrimaryKey, setStudyPrimaryKey] = useState();
  const [isEmergency, setisEmergency] = useState();
  const [studyStatus, setStudyStatus] = useState();
  const [studyFlagEmergency, setStudyFlagEmergency] = useState();
  const [allGrades, setAllGrades] = useState([]);
  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const [editableRow, setEditable] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [studyId, setStudyId] = useState();
  const [FeedbackModal, setFeedbackModal] = useState({
    isModalOpen: false,
  });
  const [remarkModal, setRemarkModal] = useState({
    isModalOpen: false,
  });
  // Handle row click to enable editing for a specific row
  const handleRowClick = (index) => {
    setEditableRowIndex((prevIndex) => (prevIndex === index ? null : index));
    // / Set clicked row as editable
  };

  // Handle blur event to stop editing
  const handleBlur = () => {
    setEditableRowIndex(null); // Reset editable row index on blur
  };
  const [feedbackData, setFeedbackData] = useState([]);
  const [remarksData, setRemarksData] = useState();
  const [studyDesc, setSelectedStudyDesc] = useState();
  const {
    userToken,
    isSitePerson,
    isSubAdmin,
    isRadiologist,
    isSuperAdmin,
    isQualityChecker,
    userID,
  } = useUser();
  const fileInputRef = useRef(null);
  const [form] = Form.useForm();
  const { toastSuccess, toastError } = useToast();
  const [excelFilters, setExcelFilters] = useState();
  const { setUnreadCount } = useUnreadMessages();
  const [filledFilters, setFilledValues] = useState();
  const [filterLoading, setFilterLoding] = useState(false);
  const [data, setData] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isRunning, setIsRunning] = useState(true); // To track if timer is running
  const [timeLeft, setTimeLeft] = useState(30);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const handleFileUploadChange = (info) => {
    setUploadedFiles(info.fileList);
  };
  const startTimer = () => {
    // If timer is not running, start it
    if (!isRunning) {
      setIsRunning(true);
      let countdown = 30; // Start from 30 seconds
      setTimeLeft(countdown);

      // Start countdown timer
      const timer = setInterval(() => {
        countdown -= 1;
        setTimeLeft(countdown);

        if (countdown <= 0) {
          clearInterval(timer); // Stop the current countdown
          getStudies(); // Call getStudies when the timer is done
          setTimeLeft(30); // Reset time left to 30
        }
      }, 1000);

      // Set the timer to repeat every 30 seconds
      setInterval(() => {
        getStudies(); // Call getStudies every 30 seconds
        setTimeLeft(30); // Reset the countdown to 30 seconds
      }, 30000); // 30 seconds interval
    } else {
      getStudies();
      setTimeLeft(30);
    }
  };
  useEffect(() => {
    // Set the interval for 30 seconds continuously
    const interval = setInterval(() => {
      if (userID != 336) getStudies(); // Call getStudies every 30 seconds
      setTimeLeft(30); // Reset time left to 30 seconds
    }, 30000); // 30 seconds interval

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Countdown timer that runs every second for the 30 seconds interval
    const countdown = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime === 0 ? 30 : prevTime - 1)); // Decrease time left every second, reset to 30 when it reaches 0
    }, 1000); // 1 second interval for countdown

    // Clean up the countdown timer when the component unmounts
    return () => clearInterval(countdown);
  }, []);

  const handleFileRemove = (file) => {
    // Remove the file from the uploaded files array
    const updatedFiles = uploadedFiles.filter((f) => f.uid !== file.uid);
    setUploadedFiles(updatedFiles);
  };

  const handleFileDelete = (file) => {
    console.log("file to delete", file);
    setFilesToDelete([...filesToDelete, file]);
    attachModal.image = attachModal.image.filter((f) => f !== file);
  };

  const handleFileDownload = (file) => {
    handleDownload(file);
  };

  const handleDownload = async (url) => {
    try {
      const response = await apiClient.get(
        `/studyInfo/history/download-document?url=${encodeURIComponent(url)}`,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "document";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const handleSubmit = async () => {
    try {
      console.log(studyPrimaryKey?.radiologist_details?.id);

      if (filesToDelete.length > 0) {
        await apiClient.patch(
          `studyInfo/delete-document/${studyPrimaryKey?.radiologist_details?.id}`,
          { images: filesToDelete },
        );

        toastSuccess("File Deleted successfully");
      }

      if (uploadedFiles.length > 0) {
        // Create FormData to append the file(s)
        const formData = new FormData();

        // Loop through the uploaded files and append them to formData under a single 'image' field
        uploadedFiles.forEach((file) => {
          formData.append("image", file.originFileObj); // Append each file under the same field name 'image'
        });

        // Send PATCH request using your custom apiClient.patch
        const response = await apiClient.patch(
          `studyInfo/document/${studyPrimaryKey?.radiologist_details?.id}`,
          formData,
        );

        if (response) {
          getStudies();
          toastSuccess("File Uploaded successfully");

          // Reset the form and uploaded files after success
          setUploadedFiles([]);
          setAttachModal({ ...attachModal, isModalOpen: false });
        } else {
          toastError("Failed to submit, please try again");
        }
      } else {
        setFilesToDelete([]);
        getStudies();
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      toastError("An error occurred, please try again");
    }
  };

  //ViewAttachmentModal
  const showAttachModal = (image) => {
    setAttachModal({ isModalOpen: true, image: image });
  };

  const handleCancelAttachModal = () => {
    setUploadedFiles([]);
    setAttachModal({ TextisModalOpen: false, image: [] });
  };

  //Add Description Modal
  const showTextModal = () => {
    setTextModal({ isModalOpen: true });
  };

  const handleOkTextModal = () => {
    setTextModal({ isModalOpen: false });
  };

  const handleCancelTextModal = () => {
    setTextModal({ TextisModalOpen: false });
  };

  //Upload Study Modal
  const handleOkStudyModal = () => {
    setUploadModal({ isModalOpen: true });
  };

  const handleCancelStudyModal = () => {
    setUploadModal({ isModalOpen: false });
  };

  const handleOk = () => {
    console.log("Preferences updated!");
  };

  //Assign Quality Checker Modal

  const showQCModal = (type = "assign") => {
    setQcModal({ isModalOpen: true, type: type });
  };

  const handleOkQCModal = () => {
    setQcModal({ isModalOpen: false, type: "" });
  };

  const handleCancelQCModal = () => {
    setQcModal({ isModalOpen: false, type: "" });
  };

  // Raadio Prefrence Modal9Assign Radiologist)
  const showPrefModal = (type = "assign") => {
    setRadioPrefenceModal({ isModalOpen: true, type: type });
  };

  const handleOkPrefModal = () => {
    setRadioPrefenceModal({ isModalOpen: true, type: "" });
  };

  const handleCancelPrefModal = () => {
    setRadioPrefenceModal({ isModalOpen: false, type: "" });
  };
  const handleCloseImageModal = () => {
    setImageModal({ isModalOpen: false, url: "" });
  };

  // feedback modal
  const showFeedbackModal = () => {
    setFeedbackModal({ isModalOpen: true });
  };

  const handleOkFeedbackModal = () => {
    setFeedbackModal({ isModalOpen: true, type: "" });
  };

  const handleCancelFeedbackModal = () => {
    setFeedbackModal({ isModalOpen: false, type: "" });
  };

  //Remark Modal

  const showRemarkModal = () => {
    setRemarkModal({ isModalOpen: true });
  };

  const handleOkRemarkModal = () => {
    setRemarkModal({ isModalOpen: true, type: "" });
  };

  const handleCancelRemarkModal = () => {
    setRemarkModal({ isModalOpen: false, type: "" });
  };

  // Edit Description Modal

  const showEditDescModal = () => {
    setEditDescModal({ isModalOpen: true });
  };
  const showRadioEditDescModal = () => {
    setEditRadioModal({ isModalOpen: true });
  };

  const handleOkEditDescModal = () => {
    setEditRadioModal({ isModalOpen: false, type: "" });
  };
  const handleOkEditRadioModal = () => {
    setEditRadioModal({ isModalOpen: false, type: "" });
  };

  const handleCancelEditDescModal = () => {
    setEditDescModal({ isModalOpen: false, type: "" });
  };

  const handleCancelEditRadioModal = () => {
    setEditRadioModal({ isModalOpen: false, type: "" });
  };

  const isImage = (url) => /\.(jpg|jpeg|png|gif|webp|jfif)$/i.test(url);

  const isPdf = (url) => /\.pdf$/i.test(url);

  const isPreviewable = (url) => isImage(url) || isPdf(url);

  const handleCopy = (url, isRegenrateLink) => {
    navigator.clipboard.writeText(url ? url : copyUrl).then(() => {
      toastSuccess(
        `${
          isRegenrateLink
            ? "New link is copied to clipboard!"
            : "URL copied to clipboard!"
        }`,
      );
    });
  };
  const getRadomUrl = async (id) => {
    setStudyId(id);
    const url = await apiClient.get(`/auth/image-url?id=${id}`);
    setCopyUrl(url?.data?.url);
    handleCopy(url?.data?.url, false);
  };
  const handleRegenrateLink = async () => {
    const url =
      studyId && (await apiClient.get(`/auth/image-url?id=${studyId}`));
    setCopyUrl(url?.data?.url);
    handleCopy(url?.data?.url, true);
  };
  const handleDeleteStudy = async (
    id,
    completeDelete,
    studyId,
    wordUrl,
    pdfUrl,
    examDate,
    patientName,
  ) => {
    try {
      if (!completeDelete) {
        const response = await apiClient.get("/orthanc/downloadStudyBundle", {
          params: {
            studyId,
            pdfUrl,
            wordUrl,
            patientName,
            examDate,
          },
          responseType: "blob", // 🔴 VERY IMPORTANT
        });

        // 2️⃣ Create download
        const blob = new Blob([response.data], {
          type: "application/zip",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = `${patientName}_${examDate}.zip`;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
        // 5️⃣ Small delay (UX safety)
        await new Promise((r) => setTimeout(r, 1000));
      }

      // 6️⃣ Delete Study
      await apiClient.delete(
        `/orthanc/deleteStudy?studyId=${id}&completeDelete=${completeDelete}`,
      );

      toastSuccess("Study downloaded & deleted successfully");
      await getStudies();
    } catch (error) {
      await getStudies();
      toastError(error?.response?.data || "Something went wrong");
    }
  };

  const handleDownloadStudy = async (studyId) => {
    const downloadUrl = `${orthancURL}/studies/${studyId}/archive`;

    // 2. Create a normal anchor link
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `study_${studyId}.zip`); // Suggests a filename

    // 3. Trigger the browser's native download mechanism
    document.body.appendChild(link);
    link.click();

    // 4. Cleanup the temporary element
    document.body.removeChild(link);
    // Note: No URL.revokeObjectURL needed as we didn't create an object URL
  };

  const handleMarkStudyUploadDone = async (studyId) => {
    try {
      await apiClient.post("/orthanc/update-isUploading", {
        studyId,
        uploadingStatus: 0,
      });
      getStudies();
    } catch (error) {
      console.log("error-->", error);
    }
  };

  const getAllFeedbacks = async (studyId) => {
    try {
      const response = await apiClient.get(`feedback?studyId=${studyId}`);
      setFeedbackData(response?.data?.feedbacks?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllRemarks = async (studyId) => {
    try {
      const response = await apiClient.get(
        `gradeAssigned?limit=10&page=1&studyInfoId=${studyId}`,
      );
      setRemarksData(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Retrieve stored filters from localStorage
    const storedFilters =
      JSON.parse(localStorage.getItem("studyFilters")) || {};

    // Map raw date values directly to Day.js instances, if they exist
    console.log(
      "time -->",
      dayjs(storedFilters.to_date)
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(0),
    );
    const formattedFilters = {
      ...storedFilters,
      exam_date_time: storedFilters.exam_date_time
        ? dayjs(storedFilters.exam_date_time)
        : undefined,
      from_date: storedFilters.from_date
        ? dayjs(storedFilters.from_date)
        : undefined,
      to_date: storedFilters.to_date ? dayjs(storedFilters.to_date) : undefined,
    };

    // Set values directly in the form
    form.setFieldsValue(formattedFilters);
  }, []);

  useEffect(() => {
    const fetchAllUnreadMessages = async () => {
      try {
        const allUnreadMessages = await apiClient.get(
          `/chat/unreadMessages?userId=${userID}`,
        );
        const data = allUnreadMessages.data.Chat;
        setUnreadCount(parseInt(data.length));
      } catch (error) {
        console.log("error", error);
      }
    };
    if (userID) fetchAllUnreadMessages();
  }, []);
  const content = (
    <div style={{ flexWrap: "wrap" }} className="d-flex gap-1">
      {copyUrl && (
        <Input style={{ maxWidth: "100%" }} value={copyUrl} readOnly />
      )}
      <Tooltip title="Copy link">
        <Button onClick={() => handleCopy()}>
          <CopyOutlined />
        </Button>
      </Tooltip>
      <Tooltip title="Regenerate link">
        <Button
          style={{ cursor: "pointer" }}
          onClick={() => handleRegenrateLink()}
        >
          <RedoOutlined />
        </Button>
      </Tooltip>
    </div>
  );
  console.log("loading", loading);

  const sendQCResponse = async (
    status,
    study_info_model_id,
    radiologist,
    selectedGrade = "",
    feedbackText = "",
    enteredRemark,
  ) => {
    try {
      const formData = {
        role_radiologist: radiologist,
        study_info_model_id: study_info_model_id,
        role_quality_checker: userID,
        status: status,
      };

      if (feedbackText.trim().length > 0) {
        formData.feedbackText = feedbackText;
      }

      if (enteredRemark.trim().length > 0) {
        formData.remark = enteredRemark;
      }

      await apiClient.post(
        "auth/create-study-status",
        selectedGrade === ""
          ? formData
          : { ...formData, grade_id: selectedGrade },
      );

      toastSuccess("Status Updated");
      await getStudies();
    } catch (err) {
      toastError("Error updating statussss", err.message);
      console.log("err", err);
    }
  };
  const handleReferByChange = (newValue, record, index) => {
    setEditable(true);
    const newData = [...data]; // Clone the data array
    // Perform null checks before updating the value
    if (newData[index] && newData[index].radiologist_details) {
      newData[index].radiologist_details.refer_by = newValue;
    }
    setData(newData);

    // Update the data state with the modified row
  };
  const orthancURL = process.env.REACT_APP_ORTHANC_URL;

  const columns = [
    {
      title: "Site Name",
      dataIndex: ["radiologist_details", "sitePerson", "name"],
      key: "name",
      width: 10,
      hidden: isSubAdmin || isSuperAdmin ? false : true,
      render: (text, record) => {
        return (
          <>
            <div>
              <span style={{ textWrap: "wrap" }}>
                {record?.radiologist_details?.sitePerson?.name}
              </span>
            </div>
          </>
        );
      },
    },

    {
      title: "Pat. Name",
      dataIndex: ["study_details", "PatientMainDicomTags", "PatientName"],
      key: "name",
      className: "study-desc-column",
      render: (text, record) => {
        return (
          <>
            {isSitePerson && (
              <div>
                {record?.radiologist_details?.emergency_flag ? (
                  <div className="site_emergancy">
                    <p>Emergency</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}

            {(isSubAdmin || isSuperAdmin) &&
              record?.radiologist_details?.status === "unread" && (
                <div>
                  {record?.radiologist_details?.emergency_flag ? (
                    <div className="site_emergancy">
                      <p>Emergency</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}

            {(isSubAdmin || isSuperAdmin) &&
              record?.radiologist_details?.status != "unread" && (
                <div>
                  {record?.radiologist_details?.study_status_flag ? (
                    <div className="site_emergancy">
                      <p>Emergency</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            {(isQualityChecker || isRadiologist) && (
              <div>
                {record?.radiologist_details?.study_status_flag ? (
                  <div className="site_emergancy">
                    <p>Emergency</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}

            <div className="site_namewarp">
              <a>
                <span
                  style={{
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    color: record?.study_details ? "black" : "gray",
                  }}
                  onClick={() => {
                    handleClick(
                      record?.study_details?.MainDicomTags?.StudyInstanceUID,
                      record?.radiologist_details?.id,
                    );
                  }}
                >
                  {record?.study_details?.PatientMainDicomTags?.PatientName ||
                    record?.radiologist_details?.patient_name}
                </span>
              </a>
            </div>
          </>
        );
      },
    },
    {
      title: " Stu. Desc",
      key: "studyDescription",
      render: (text, record) => {
        return (
          <>
            <div>
              <span style={{ textWrap: "wrap" }}>
                <span>
                  {record?.radiologist_details?.history_description == ""
                    ? record?.study_details?.MainDicomTags?.StudyDescription
                    : record?.radiologist_details?.history_description}
                </span>
              </span>
              {(isSitePerson || isSubAdmin || isSuperAdmin) && (
                <Tooltip title="Edit Study Desc">
                  <Button
                    onClick={() => {
                      setSelectedStudyDesc(
                        record?.radiologist_details?.history_description == ""
                          ? record?.study_details?.MainDicomTags
                              ?.StudyDescription
                          : record?.radiologist_details?.history_description,
                      );
                      showEditDescModal();
                      setStudyPrimaryKey(record?.radiologist_details?.id);
                    }}
                  >
                    {" "}
                    <EditOutlined />
                    <Tooltip title="Edit Study Description"></Tooltip>
                  </Button>
                </Tooltip>
              )}
            </div>
          </>
        );
      },
    },
    {
      title: "Study Prefrence",
      key: "prefrenceModal",
      hidden: isSuperAdmin || isSubAdmin || isSitePerson ? false : true,
      width: 10,
      render: (text, record) => {
        return (
          <>
            <div>
              <span style={{ textWrap: "wrap" }}>
                <span>
                  {record?.radiologist_details?.studyRadiologistPreferences
                    ?.length > 0 ? (
                    <span
                      style={{
                        color: "white",
                        backgroundColor: "green",
                        padding: "5px 10px",
                        borderRadius: "999px",
                        display: "inline-block",
                        minWidth: "24px",
                        textAlign: "center",
                        animation: "blinker 1s linear infinite",
                      }}
                    >
                      {
                        record?.radiologist_details?.studyRadiologistPreferences
                          ?.length
                      }
                    </span>
                  ) : (
                    "0"
                  )}
                </span>
              </span>
              {(isSitePerson || isSubAdmin || isSuperAdmin) && (
                <Tooltip title="Edit Study Prefrence">
                  <Button
                    onClick={() => {
                      showRadioEditDescModal();
                      setStudyPrimaryKey(record?.radiologist_details?.id);
                      setisEmergency(
                        record?.radiologist_details?.emergency_flag,
                      );
                      setStudyStatus(record?.radiologist_details?.status);
                    }}
                  >
                    {" "}
                    <EditOutlined />
                    <Tooltip title="Set Radiologist"></Tooltip>
                  </Button>
                </Tooltip>
              )}
            </div>
          </>
        );
      },
    },
    {
      title: "Sex",
      dataIndex: ["radiologist_details", "gender"],
      key: "gender",
      width: 35,
      render: (text) => {
        return (
          <>
            <span>{text[0]}</span>
          </>
        );
      },
    },
    {
      title: "Age",
      dataIndex: ["radiologist_details", "age"],
      key: "age",
      width: 20,
      render: (text) => {
        return (
          <>
            <span>{text == "30" ? text : text}</span>
          </>
        );
      },
    },

    {
      title: "Exam",
      dataIndex: ["radiologist_details"],
      key: "uploadtime",
      width: 8,
      render: (record) => {
        return (
          <>
            <div className="d-flex just-content-center align-items-center flex-column">
              <span>
                {moment.utc(record?.exam_date_time).format("DD/MM/YYYY")}
              </span>
              <div
                style={{
                  height: "2px",
                  width: "50px",
                  background: "grey",
                  margin: "5px 0px",
                }}
              ></div>
              <span>
                {moment.utc(record?.exam_date_time).format("hh:mm A")}
              </span>
            </div>
          </>
        );
      },
    },

    {
      title: "Upload",
      dataIndex: ["radiologist_details"],
      key: "studyDate",
      width: 8,
      render: (record) => {
        return (
          <>
            <div className="d-flex just-content-center align-items-center flex-column">
              <span>
                {moment
                  .utc(record?.upload_date_time)
                  .utcOffset("+05:30")
                  .format("DD/MM/YY")}
              </span>
              <div
                style={{
                  height: "2px",
                  width: "50px",
                  background: "grey",
                  margin: "5px 0px",
                }}
              ></div>

              <span>
                {moment
                  .utc(record?.upload_date_time)
                  .utcOffset("+05:30")
                  .format("hh:mm A")}
              </span>
            </div>
          </>
        );
      },
    },

    {
      title: "Hist/Att.",
      key: "history",
      width: 8,
      render: (record) => {
        return (
          <>
            {" "}
            <div className="align-items-center table_spance">
              <Space
                className="d-flex flex-column  align-items-center justify-content-between "
                style={{ padding: "5px" }}
              >
                <Tooltip title="History">
                  <Button
                    onClick={() => {
                      setStudyPrimaryKey(record?.radiologist_details?.id);
                      showTextModal();
                    }}
                  >
                    <WechatOutlined
                      style={{
                        color:
                          record?.radiologist_details?.history_present > 0
                            ? "#25D366"
                            : "",
                      }}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="View Attachments">
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0px 2px",
                    }}
                    onClick={() => {
                      setStudyPrimaryKey(record);
                      showAttachModal(record?.radiologist_details?.image);
                    }}
                    // disabled={!record?.radiologist_details?.image?.length}
                  >
                    <LinkOutlined />
                    <div style={{ padding: "0px 5px" }}>
                      ({record?.radiologist_details?.image?.length || 0})
                    </div>
                  </Button>
                </Tooltip>
              </Space>

              <div className="d-flex flex-column align-items-center justify-content-between ">
                <span className="pe-2">
                  {moment(record?.radiologist_details?.history_date_time)
                    .utcOffset("+05:30")
                    .format("DD/MM/YY")}
                </span>
                <div
                  style={{
                    height: "2px",
                    width: "50px",
                    background: "grey",
                    margin: "5px 0px",
                  }}
                ></div>
                <span className="ps-2">
                  {moment(record?.radiologist_details?.history_date_time)
                    .utcOffset("+05:30")
                    .format("hh:mm A")}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: "Ref. By",
      dataIndex: [
        "study_details",
        "PatientMainDicomTags",
        "ReferringPhysicianName",
      ],
      key: "refer_by",
      className: "ref-column",

      render: (text, record, index) => {
        // Check if the column should be visible based on user roles
        if (isSuperAdmin || isSubAdmin || isSitePerson) {
          // If this is the clicked row, make the cell editable

          // Check if the referring physician name is empty or the radiologist refer_by is empty
          if (editableRowIndex === index) {
            return (
              <div onClick={() => setEditable(!editableRow)}>
                <EditableCell
                  editableRow={editableRow}
                  setEditableRow={setEditable}
                  value={
                    // If both are empty, show edit
                    record?.radiologist_details?.refer_by === "" &&
                    record?.study_details?.MainDicomTags
                      ?.ReferringPhysicianName === ""
                      ? "" // Or provide a fallback value if needed
                      : record?.radiologist_details?.refer_by === ""
                        ? record.study_details.MainDicomTags
                            .ReferringPhysicianName
                        : record?.radiologist_details?.refer_by
                  }
                  onChange={(newValue) =>
                    handleReferByChange(newValue, record, index)
                  }
                  record={record}
                  setEditableRowIndex={setEditableRowIndex}
                  onBlur={handleBlur}
                  fetchData={getStudies} // Reset editable state on blur
                />
              </div>
            );
          }

          // Otherwise, return the non-editable value
          return (
            <Button
              className="cursor-pointer"
              onClick={() => handleRowClick(index)}
            >
              {record?.radiologist_details?.refer_by === "" &&
              record?.study_details?.MainDicomTags?.ReferringPhysicianName ===
                "" ? (
                <Edit /> // Or another placeholder for empty fields
              ) : record?.radiologist_details?.refer_by === "" ? (
                record?.study_details?.MainDicomTags?.ReferringPhysicianName
              ) : (
                record?.radiologist_details?.refer_by
              )}
            </Button>
          );
        }
        return <Edit />; // Hide the column for other roles
      },
      hidden: isSuperAdmin || isSubAdmin || isSitePerson ? false : true,
    },

    {
      title: "Mod.",
      dataIndex: ["radiologist_details", "modality"],
      key: "modality",
      width: 20,
    },

    {
      title: () => <div>No. Of Imgs</div>,
      key: "instances",
      width: 3,
      render: (record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // centers horizontally
              gap: 4,
            }}
          >
            <span>
              {record?.study_details?.Series?.length}/
              {record?.study_details?.totalImages}
            </span>

            {record?.radiologist_details?.is_uploading != 0 && (
              <Tag
                color="red"
                style={{
                  padding: "2px 5px",
                  textAlign: "center",
                  fontSize: 12,
                }}
              >
                Uploading...
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Radio",
      key: "radiologist",
      width: 30,
      render: (record) => {
        return (
          <>
            <div className="mx-1">
              <Tooltip title="Select Radiologist">
                <Button
                  style={{
                    width: "100%",
                    height: "100%",
                    whiteSpace: "normal",
                  }}
                  disabled={record?.radiologist_details?.status == "final"}
                  onClick={() => {
                    showPrefModal();
                    setCurrentStudyID(record?.radiologist_details?.study_id);
                    setStudyPrimaryKey(record?.radiologist_details?.id);
                    setisEmergency(record?.radiologist_details?.emergency_flag);
                    setStudyStatus(record?.radiologist_details?.status);
                    setStudyFlagEmergency(
                      record?.radiologist_details?.study_status_flag,
                    );
                  }}
                >
                  <FontAwesomeIcon icon={faCircleUser} />
                </Button>
              </Tooltip>

              <Tooltip title="Current Assigned Radioligst" placement="right">
                <div
                  style={{
                    background: "rgb(174 174 174 / 32%)",
                    borderRadius: "8%",
                  }}
                >
                  <span style={{ textWrap: "wrap" }}>
                    {
                      record?.radiologist_details
                        ?.current_radiologist_assigned_name
                    }
                  </span>
                </div>
                <div className="d-flex justify-content-center mt-1 ">
                  {record?.radiologist_details
                    ?.current_radiologist_assigned_date && (
                    <span>
                      {moment(
                        record?.radiologist_details
                          ?.current_radiologist_assigned_date,
                      ).format(" DD/MM/YYYY")}
                    </span>
                  )}

                  {record?.radiologist_details
                    ?.current_radiologist_assigned_date && (
                    <div
                      style={{
                        height: "16px",
                        width: "2px",
                        background: "grey",
                        margin: "1px 4px",
                      }}
                    ></div>
                  )}

                  {record?.radiologist_details
                    ?.current_radiologist_assigned_date && (
                    <span>
                      {moment(
                        record?.radiologist_details
                          ?.current_radiologist_assigned_date,
                      ).format("h:mm A")}
                    </span>
                  )}
                </div>
              </Tooltip>
            </div>
          </>
        );
      },
      hidden: isSuperAdmin || isSubAdmin ? false : true,
    },

    {
      title: " QC ",
      width: 5,
      key: "qc",
      render: (record) => {
        return (
          <>
            <div className="mx-1">
              <Tooltip title="Select Quality Checker">
                <Button
                  style={{ width: "100%", height: "100%", textWrap: "wrap" }}
                  disabled={
                    record?.radiologist_details?.status === "assigned" ||
                    record?.radiologist_details?.status === "unread" ||
                    record?.radiologist_details?.status === "final"
                  }
                  onClick={() => {
                    showQCModal();
                    setStudyPrimaryKey(record?.radiologist_details?.id);
                  }}
                >
                  <FontAwesomeIcon icon={faCircleUser} />
                </Button>
              </Tooltip>

              <Tooltip title="Current Assigned QC" placement="right">
                <div
                  style={{
                    background: "rgb(174 174 174 / 32%)",
                    borderRadius: "8%",
                  }}
                >
                  <span style={{ textWrap: "wrap" }}>
                    {
                      record?.radiologist_details
                        ?.current_quality_checker_assigned_name
                    }
                  </span>
                </div>
                <div className="d-flex justify-content-center mt-1 ">
                  {record?.radiologist_details
                    ?.current_quality_checker_assigned_name && (
                    <span>
                      {moment(
                        record?.radiologist_details
                          ?.current_quality_checker_assigned_date,
                      ).format(" DD/MM/YYYY")}
                    </span>
                  )}

                  {record?.radiologist_details
                    ?.current_quality_checker_assigned_date && (
                    <div
                      style={{
                        height: "16px",
                        width: "2px",
                        background: "grey",
                        margin: "1px 4px",
                      }}
                    ></div>
                  )}

                  {record?.radiologist_details
                    ?.current_quality_checker_assigned_date && (
                    <span>
                      {moment(
                        record?.radiologist_details
                          ?.current_quality_checker_assigned_date,
                      ).format("h:mm A")}
                    </span>
                  )}
                </div>
              </Tooltip>
            </div>
          </>
        );
      },
      hidden: isSuperAdmin || isSubAdmin ? false : true,
    },
    {
      title: "Status",
      dataIndex: "study_details",
      key: "status",
      width: 100,
      render: (text, record) => {
        return (
          <>
            {record?.radiologist_details?.status !== "final" ? (
              <div className="d-flex flex-column justify-content-center align-items-center gap-10px">
                <Button
                  onClick={() => {
                    setGradeModal({
                      status: "final",
                      grade: true,
                      study_info_model_id: record?.radiologist_details?.id,
                      radiologist:
                        record?.radiologist_details
                          ?.current_radiologist_assigned_id,
                      isModalOpen: true,
                    });
                  }}
                >
                  Accept
                </Button>
                <Button
                  onClick={() => {
                    setGradeModal({
                      status: "revise",
                      grade: false,
                      study_info_model_id: record?.radiologist_details?.id,
                      radiologist:
                        record?.radiologist_details
                          ?.current_radiologist_assigned_id,
                      isModalOpen: true,
                    });
                  }}
                >
                  Revise
                </Button>
              </div>
            ) : (
              <p>Report is final</p>
            )}
          </>
        );
      },
      hidden: !isQualityChecker ? true : false,
    },
    {
      title: "Rep. Info",
      key: "reportInfo",
      width: 5,
      render: (record) => {
        return (
          <>
            <Space
              className="d-flex align-items-center justify-content-center m-auto section_info_repit"
              style={{ width: "60%" }}
            >
              {(isSuperAdmin || isSubAdmin) && (
                <Tooltip title="Pdf">
                  <a target="blank" href={record?.radiologist_details?.pdf_url}>
                    <Button disabled={!record?.radiologist_details?.pdf_url}>
                      <FilePdfOutlined
                        style={{
                          color: record?.radiologist_details
                            ?.is_site_person_download_report
                            ? "#E19898"
                            : "",
                        }}
                      />
                    </Button>
                  </a>
                </Tooltip>
              )}

              {isSitePerson && (
                <Tooltip title="Pdf">
                  <a target="blank" href={record?.radiologist_details?.pdf_url}>
                    <Button
                      onClick={async () => {
                        if (isSitePerson) {
                          await apiClient.patch(
                            `/studyInfo/report/update-download-study?studyInfoId=${record?.radiologist_details?.id}`,
                          );
                        }
                      }}
                      disabled={
                        !record?.radiologist_details?.pdf_url ||
                        record?.radiologist_details?.status !== "final"
                      }
                    >
                      <FilePdfOutlined />
                    </Button>
                  </a>
                </Tooltip>
              )}

              {(isQualityChecker || isRadiologist) && (
                <Tooltip title="Pdf">
                  <a
                    target="blank"
                    href={record?.radiologist_details?.radio_pdf_url}
                  >
                    <Button
                      disabled={!record?.radiologist_details?.radio_pdf_url}
                    >
                      <FilePdfOutlined />
                    </Button>
                  </a>
                </Tooltip>
              )}

              {(isSuperAdmin || isSubAdmin) && (
                <Tooltip title="Word">
                  <a
                    target="blank"
                    href={record?.radiologist_details?.word_url}
                  >
                    <Button disabled={!record?.radiologist_details?.word_url}>
                      <FileWordOutlined
                        style={{
                          color: record?.radiologist_details
                            ?.is_site_person_download_report
                            ? "#E19898"
                            : "",
                        }}
                      />
                    </Button>
                  </a>
                </Tooltip>
              )}
              {isSitePerson && (
                <Tooltip title="Word">
                  <a
                    target="blank"
                    href={record?.radiologist_details?.word_url}
                  >
                    <Button
                      onClick={async () => {
                        if (isSitePerson) {
                          await apiClient.patch(
                            `/studyInfo/report/update-download-study?studyInfoId=${record?.radiologist_details?.id}`,
                          );
                        }
                      }}
                      disabled={
                        !record?.radiologist_details?.word_url ||
                        record?.radiologist_details?.status !== "final"
                      }
                    >
                      <FileWordOutlined />
                    </Button>
                  </a>
                </Tooltip>
              )}

              {(isRadiologist || isQualityChecker) && (
                <Tooltip title="Word">
                  <a
                    target="blank"
                    href={record?.radiologist_details?.radio_word_url}
                  >
                    <Button
                      disabled={!record?.radiologist_details?.radio_word_url}
                    >
                      <FileWordOutlined />
                    </Button>
                  </a>
                </Tooltip>
              )}

              {(isSubAdmin || isSuperAdmin || isRadiologist) && (
                <Tooltip title="Revise Reason">
                  <Button
                    className="feedback_info remark_info"
                    onClick={() => {
                      getAllFeedbacks(record?.radiologist_details?.id);
                      showFeedbackModal();
                    }}
                  >
                    <img
                      className="remarkimgone"
                      height="23px"
                      width="23px"
                      src={feedback}
                    ></img>
                    <img
                      className="remarkimgtwo"
                      height="23px"
                      width="23px"
                      src={feedbackicon}
                    ></img>
                  </Button>
                </Tooltip>
              )}

              {(isSubAdmin || isSuperAdmin) && (
                <Tooltip title="Remark">
                  <Button
                    className="remark_info"
                    onClick={() => {
                      getAllRemarks(record?.radiologist_details?.id);
                      showRemarkModal();
                    }}
                  >
                    <img
                      className="remarkimgone"
                      height="15px"
                      width="15px"
                      src={remarkicon}
                    ></img>
                    <img
                      className="remarkimgtwo"
                      height="15px"
                      width="15px"
                      src={remarkiconhover}
                    ></img>
                  </Button>
                </Tooltip>
              )}
            </Space>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ padding: "5px" }}
            >
              {record?.radiologist_details?.status == "unread" && (
                <Tooltip title="Report Status">
                  <span
                    style={{ background: "#F0F0F0" }}
                    className="custom-badge status-gray"
                  >
                    Unread
                  </span>
                </Tooltip>
              )}
              {console.log(
                record?.study_details?.MainDicomTags?.StudyDescription,
                "hjdh",
              )}
              {record?.radiologist_details?.status == "assigned" && (
                <Tooltip title="Report Status">
                  <span
                    style={{ background: "#F0F0F0" }}
                    className="custom-badge status-gray"
                  >
                    {/* Assigned */} {isSitePerson ? "Unread" : "Pending"}
                  </span>
                </Tooltip>
              )}

              {record?.radiologist_details?.status == "read" && (
                <Tooltip title="Report Status">
                  <span className="badge bg-primary-light">
                    {isSitePerson ? "Unread" : "Pending"}
                  </span>
                </Tooltip>
              )}

              {!isSitePerson &&
                record?.radiologist_details?.status == "revise" && (
                  <Tooltip title="Report Status">
                    <span className="custom-badge status-orange">Revise</span>
                  </Tooltip>
                )}
              {isSitePerson &&
                record?.radiologist_details?.status == "revise" && (
                  <Tooltip title="Report Status">
                    <span className="badge bg-primary-light">Unread</span>
                  </Tooltip>
                )}
              {record?.radiologist_details?.status == "final" && (
                <Tooltip title="Report Status">
                  <span
                    style={{
                      background: record?.radiologist_details
                        ?.is_site_person_download_report
                        ? "#E19898"
                        : "#008000",
                      color: "white",
                    }}
                    className="custom-badge "
                  >
                    Final
                  </span>
                </Tooltip>
              )}
            </div>

            {record?.radiologist_details?.finalStudyDateTime && (
              <div className="d-flex justify-content-center">
                <span>
                  {moment(
                    record?.radiologist_details?.finalStudyDateTime,
                  ).format(" DD/MM/YYYY")}
                </span>

                <div
                  style={{
                    height: "16px",
                    width: "2px",
                    background: "grey",
                    margin: "1px 4px",
                  }}
                ></div>

                <span>
                  {moment(
                    record?.radiologist_details?.finalStudyDateTime,
                  ).format("h:mm A")}
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 5,
      render: (text, record) => {
        return (
          <>
            <div className="d-flex justify-content-center align-items-center section_info_repit m-auto">
              <div className="px-2">
                <Popover
                  content={content}
                  placement="bottom"
                  title="Share Study"
                  trigger="click"
                >
                  <Tooltip
                    title={
                      record?.study_details
                        ? "Share study"
                        : "Study data not available"
                    }
                  >
                    <Button
                      disabled={!record?.study_details}
                      onClick={() =>
                        getRadomUrl(record?.radiologist_details?.id)
                      }
                    >
                      <ShareAltOutlined />
                    </Button>
                  </Tooltip>
                </Popover>
              </div>

              <div>
                <Tooltip
                  title={
                    record?.study_details
                      ? "Download Study"
                      : "Study data not available"
                  }
                >
                  <Button
                    className="pe-1"
                    disabled={!record?.study_details}
                    onClick={() =>
                      handleDownloadStudy(record.study_details?.ID)
                    }
                  >
                    <DownloadOutlined />
                  </Button>

                  {/* <a
                    href={
                      record?.study_details
                        ? `${orthancURL}/studies/${record.study_details?.ID}/archive`
                        : undefined
                    }
                    onClick={(e) => {
                      if (!record?.study_details) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <Button className="pe-1" disabled={!record?.study_details}>
                      <DownloadOutlined />
                    </Button>
                  </a> */}
                </Tooltip>
              </div>

              <div>
                <Tooltip title="View Study">
                  <Button
                    disabled={!record?.study_details}
                    onClick={() => {
                      handleClick(
                        record.study_details?.MainDicomTags.StudyInstanceUID,
                        record?.radiologist_details?.id,
                        record?.radiologist_details
                          ?.current_radiologist_assigned?.id,
                      );
                    }}
                  >
                    <FolderViewOutlined size={14} />
                  </Button>
                </Tooltip>
              </div>

              <div>
                <Tooltip title="Open in OHIF Viewer">
                  <Button
                    disabled={!record?.study_details}
                    onClick={() =>
                      openOhifViewer(
                        record?.study_details?.MainDicomTags?.StudyInstanceUID,
                      )
                    }
                  >
                    <LinkOutlined size={14} />
                  </Button>
                </Tooltip>
              </div>

              {(isSubAdmin || isSuperAdmin) && (
                <div>
                  <Tooltip title="View Timeline">
                    <Link
                      to={`/studyTimeline/${record.radiologist_details?.id}`}
                      className="btn"
                    >
                      <img src={timeline} height="18px" width="18px"></img>
                    </Link>
                  </Tooltip>
                </div>
              )}
              {isSuperAdmin && (
                <div>
                  <Tooltip
                    title={
                      record?.study_details
                        ? "Delete Images of this study"
                        : "Image data not available"
                    }
                  >
                    <Popconfirm
                      title="Are you sure you want to delete & download images of this study?"
                      onConfirm={() =>
                        handleDeleteStudy(
                          record?.radiologist_details?.study_id,
                          false,
                          record.study_details?.ID,
                          record?.radiologist_details?.word_url,
                          record?.radiologist_details?.pdf_url,
                          record?.radiologist_details?.exam_date_time,
                          record?.study_details?.PatientMainDicomTags
                            ?.PatientName ||
                            record?.radiologist_details?.patient_name,
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        style={{ color: "red" }}
                        disabled={!record?.study_details}
                      >
                        <DeleteOutlined />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                </div>
              )}
              {isSuperAdmin && (
                <div style={{ marginLeft: "10px", cursor: "pointer" }}>
                  <Tooltip title="Mark upload status done">
                    <Popconfirm
                      title="Are you sure you want to mark this study upload done?"
                      onConfirm={() =>
                        handleMarkStudyUploadDone(
                          record?.radiologist_details?.study_id,
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        style={{ color: "blue" }}
                        disabled={!record?.radiologist_details.is_uploading}
                      >
                        <CheckCircleOutlined />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                </div>
              )}

              {isSuperAdmin && userID == 272 && (
                <div style={{ marginLeft: 10 }}>
                  <Tooltip
                    title={
                      record?.study_details
                        ? "Delete complete image"
                        : "Image data not available"
                    }
                  >
                    <Popconfirm
                      title="Are you sure you want to delete this image from orthanc and database?"
                      onConfirm={() =>
                        handleDeleteStudy(
                          record?.radiologist_details?.study_id,
                          true,
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button style={{ color: "red" }}>
                        <DeleteOutlined />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                </div>
              )}
            </div>
          </>
        );
      },
    },
  ].filter((item) => !item.hidden);

  const getStudies = async () => {
    setLoading(true);
    setFilterLoding(true);

    try {
      // Retrieve filters from local storage
      const storedFilters =
        JSON.parse(localStorage.getItem("studyFilters")) || {};
      setFilterLoding(false);
      const {
        modality,
        site,
        PatientName,
        history_description,
        refer_by,
        exam_date_time,
        from_date,
        to_date,
        category,
        status,
      } = storedFilters;

      setFilledValues(storedFilters);

      const response = await axios.get(
        `${baseURl}/orthanc/getAllStudiesList?page=${currentPage.current}&limit=${limit.current}&modality=${
          modality || ""
        }&site_person=${site || ""}&patient_name=${
          PatientName || ""
        }&history_description=${history_description || ""}&refer_by=${
          refer_by || ""
        }&exam_date_time=${exam_date_time || ""}&from_date=${
          from_date || ""
        }&to_date=${to_date || ""}&category=${category || ""}&status=${
          status || ""
        }&${
          (isRadiologist && `radiologistId=${userID}`) ||
          (isSitePerson && `sitePersonId=${userID}`) ||
          (isSubAdmin && `subAdminId=${userID}`) ||
          (isSuperAdmin && `&superAdminId=${userID}`) ||
          (isQualityChecker && `&qualityCheckerId=${userID}`)
        }`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        },
      );
      const data = response?.data?.studiesData || {};
      const { studiesDetails = [], radiologistDetails = [], pagination } = data;

      // Map study_id to radiologist details
      // const radiologistMap = radiologistDetails.reduce((map, radiologist) => {
      //   if (radiologist) {
      //     map[radiologist.study_id] = radiologist;
      //   }
      //   return map;
      // }, {});
      // console.log("radiologistmap-->",radiologistMap)
      const studyMap = studiesDetails.reduce((map, study) => {
        if (study) {
          map[study.ID] = study;
        }
        return map;
      }, {});
      console.log("studyMap==>", studyMap);
      // const combined = studiesDetails
      //   .map((study) => ({
      //     study_details: study,
      //     radiologist_details: radiologistMap[study.ID] || null,
      //   }))
      //   .filter((entry) => entry.radiologist_details !== null);
      const combined = radiologistDetails.map((radio) => ({
        study_details: studyMap[radio.study_id] || null,
        radiologist_details: radio,
      }));
      combined.total = pagination.totalRecords;
      console.log("combnined studued--->", combined);
      setStudyData(combined);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filterExist) {
      onSearch(searchValues);
    } else {
      console.log("curren pagesdfas--->", currentPage);
      getStudies();
    }
  }, [uploadModal.isModalOpen, toggleStudies]);

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await apiClient.post("/orthanc/uploadStudy", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("File uploaded successfully:", response.data);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  // const viewerURL = process.env.REACT_APP_BASE_URL_VIWER_URL;

  // const handleClick = (uId, studyid) => {
  //   if (!uId || !studyid) {
  //     return;
  //   }

  //   const url = `${viewerURL}/${userID}/${studyid}?StudyInstanceUIDs=${uId}`;

  //   // Open in a new tab
  //   window.open(url, "_blank");

  //   // Optional: If you still want to set iframe and modal state
  //   setIframeUrl(url);
  //   setShowModal(true);
  // };
  const handleClick = (uId, studyid, currentRadio) => {
    console.log("currentRadio---->", currentRadio);
    const targetUser = currentRadio || userID;
    const url = `/viewer/${uId}/${targetUser}/${studyid}`;
    window.open(url, "_blank");
  };

  const openOhifViewer = (studyInstanceUID) => {
    if (!studyInstanceUID) return;
    const base =
      process.env.REACT_APP_OHIF_VIEWER_URL || "http://localhost:3000/viewer";
    const ohifUrl = `${base}?StudyInstanceUIDs=${encodeURIComponent(studyInstanceUID)}`;
    window.open(ohifUrl, "_blank");
  };
  const showUploadModal = () => {
    setUploadModal({ isModalOpen: true });
  };
  const onSearch = async (values) => {
    setExcelFilters(values);
    setSearchValues(values);
    handleBlur();
    // Prepare filters
    const modality = values?.modality;
    const site = values?.site;
    const PatientName = values?.PatientName;
    const history_description = values?.history_description;
    const refer_by = values?.refer_by;
    const exam_date_time = values?.exam_date_time
      ? values.exam_date_time.format("YYYY-MM-DDT00:00:00.SSS[Z]")
      : "";
    const from_date = values?.from_date
      ? values.from_date.format("YYYY-MM-DD")
      : "";
    const to_date = values?.to_date ? values.to_date.format("YYYY-MM-DD") : "";
    const category = values?.category;
    const status = values?.status;

    // Combine filters for API
    const filter =
      modality ||
      site ||
      PatientName ||
      history_description ||
      refer_by ||
      exam_date_time ||
      from_date ||
      to_date ||
      category ||
      status;

    // Store filters in local storage
    localStorage.setItem(
      "studyFilters",
      JSON.stringify({
        modality,
        site,
        PatientName,
        history_description,
        refer_by,
        exam_date_time,
        from_date,
        to_date,
        category,
        status,
      }),
    );

    // Indicate filters are present
    if (filter) {
      setFilterExist(true);
    }
    try {
      setLoading(true);
      const response = await apiClient.get(
        `${`orthanc/getAllStudiesList`}?page=${currentPage.current}&limit=${limit.current}&refer_by=${
          refer_by || ""
        }&history_description=${history_description || ""}&patient_name=${
          PatientName || ""
        }&modality=${modality || ""}&site_person=${site || ""}&exam_date_time=${
          exam_date_time || ""
        }&from_date=${from_date || ""}&to_date=${to_date || ""}&category=${
          category || ""
        }&status=${status || ""}${
          (isRadiologist && `&radiologistId=${userID}`) ||
          (isSitePerson && `&sitePersonId=${userID}`) ||
          (isSubAdmin && `&subAdminId=${userID}`) ||
          (isSuperAdmin && `&superAdminId=${userID}`) ||
          (isQualityChecker && `&qualityCheckerId=${userID}`)
        }`,
      );
      const data = response?.data?.studiesData || {};
      const { studiesDetails = [], radiologistDetails = [], pagination } = data;

      // Map study_id to radiologist details
      // const radiologistMap = radiologistDetails.reduce((map, radiologist) => {
      //   if (radiologist) {
      //     map[radiologist.study_id] = radiologist;
      //   }
      //   return map;
      // }, {});
      const studyMap = studiesDetails.reduce((map, study) => {
        if (study) {
          map[study.ID] = study;
        }
        return map;
      }, {});
      // Combine study details with radiologist details
      // const combined = studiesDetails
      //   .map((study) => ({
      //     study_details: study,
      //     radiologist_details: radiologistMap[study.ID] || null,
      //   }))
      //   .filter((entry) => entry.radiologist_details !== null);
      const combined = radiologistDetails.map((radio) => ({
        study_details: studyMap[radio.study_id] || null,
        radiologist_details: radio,
      }));
      combined.total = pagination.totalRecords;
      setStudyData(combined);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const isImageUrl = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const extension = url.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  // const isDocUrl = (url) => {
  //   const imageExtensions = ["doc", "docx", "xlsx", "pptx"];
  //   const extension = url.split(".").pop().toLowerCase();
  //   // console.log("extensions-->", extension, imageExtensions.includes(extension));
  //   return imageExtensions.includes(extension);
  // };

  const handleResetSearch = () => {
    // Remove filters from local storage
    // Explicitly set 'to_date' to undefined in resetValues
    console.log("filledFilters", filledFilters);
    localStorage.removeItem("studyFilters");
    setFilledValues();

    form.setFieldsValue({
      PatientName: undefined,
      category: undefined,
      exam_date_time: undefined,
      from_date: undefined,
      history_description: undefined,
      modality: undefined,
      refer_by: undefined,
      site: undefined,
      status: undefined,
      to_date: undefined,
    });

    // Update the search values state
    // setSearchValues(resetValues);

    // Reset the filter state
    setFilterExist(false);
    setExcelFilters({});

    // Trigger the API call or data fetch to get studies
    getStudies();
  };

  const getAllSiteNames = async () => {
    try {
      const resposne = await apiClient.get("/users?role=siteperson&limit=1000");
      SetSiteData(resposne.data.users.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getGrades = async () => {
    try {
      const response = await apiClient.get("/grades?page=1&limit=1000");
      setAllGrades(response?.data?.grades?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseURl}/category`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setCategories(response?.data?.category?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleExcelDownload = async () => {
    setIsLoadingExcel(true);
    const referBY = excelFilters?.refer_by;
    const PatientName = excelFilters?.PatientName;
    const exam_date = excelFilters?.exam_date_time
      ? excelFilters.exam_date_time.format("YYYY-MM-DDT00:00:00.SSS[Z]")
      : "";

    const from = excelFilters?.from_date
      ? excelFilters.from_date.format("YYYY-MM-DD")
      : "";
    const to = excelFilters?.to_date
      ? excelFilters.to_date.format("YYYY-MM-DD")
      : "";
    const historyDesc = excelFilters?.history_description;
    const modality = excelFilters?.modality;
    const site = excelFilters?.site;
    const status = excelFilters?.status;
    console.log("Status filter-->", excelFilters);
    const category =
      excelFilters?.category == "all" ? "" : excelFilters?.category;
    try {
      const response = await apiClient.get(
        `orthanc/download-excel-studies?limit=1000000&refer_by=${
          referBY || ""
        }&history_description=${historyDesc || ""}&patient_name=${
          PatientName || ""
        }&modality=${modality || ""}&site_person=${site || ""}&exam_date_time=${
          exam_date || ""
        }&from_date=${from || ""}&category=${category || ""}&to_date=${
          to || ""
        }&status=${status || ""}${
          (isRadiologist && `radiologistId=${userID}`) ||
          (isSitePerson && `sitePersonId=${userID}`) ||
          (isSubAdmin && `subAdminId=${userID}`) ||
          (isSuperAdmin && `&superAdminId=${userID}`) ||
          (isQualityChecker && `&qualityCheckerId=${userID}`)
        }`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`, // Include the token here
            "Content-Type": "application/json",
          },
          responseType: "blob", // Important for downloading files
        },
      );
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const blobUrl = window.URL.createObjectURL(blob); // Create a Blob URL

      // Create a temporary link element
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${new Date().toISOString().split("T")[0]}-reports.xlsx`; // Set the desired file name with today's date
      document.body.appendChild(a);
      a.click(); // Trigger the download
      document.body.removeChild(a);
      // Optionally revoke the Blob URL after some time to free memory
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    } finally {
      setIsLoadingExcel(false);
    }
  };
  useEffect(() => {
    getAllSiteNames();
    getGrades();
    fetchCategories();
  }, []);
  const fetchRadioMetrics = async () => {
    try {
      const response = await apiClient.get("/availability/get-radio-metrics");
      setRadioMetrics(response?.data?.metrics);
      setAllRadioMetrics(response?.data?.metrics);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isSubAdmin || isSuperAdmin) fetchRadioMetrics();
  }, []);
  useEffect(() => {
    socket.on("radio:status", ({ radioId, status }) => {
      console.log("isRadio status-->", radioId, status);
      if (isSubAdmin || isSuperAdmin) {
        setAllRadioMetrics((metrics) =>
          [...metrics]
            .map((elem) => {
              if (elem.radiologist.id != radioId) return elem;
              const delta = {
                assigned: 0,
                read: 0,
                revise: 0,
                final: 0,
              };
              if (status === "read") {
                delta.assigned = -1;
                delta.read = 1;
              }
              if (status == "assigned") {
                delta.assigned = 1;
              }
              if (status == "revise") {
                delta.revise = 1;
                delta.read = -1;
              }
              if (status == "final") {
                delta.final = 1;
                delta.revise = -1;
              }
              return {
                ...elem,
                radiologist: {
                  ...elem.radiologist,
                  assigned: elem.radiologist.assigned + delta.assigned,
                  read: elem.radiologist.read + delta.read,
                  revise: elem.radiologist.revise + delta.revise,
                  final: elem.radiologist.final + delta.final,
                },
              };
            })
            .sort((a, b) => a.radiologist.final - b.radiologist.final),
        );
        setRadioMetrics((metrics) =>
          [...metrics]
            .map((elem) => {
              if (elem.radiologist.id != radioId) return elem;
              const delta = {
                assigned: 0,
                read: 0,
                revise: 0,
                final: 0,
              };
              if (status === "read") {
                delta.assigned = -1;
                delta.read = 1;
              }
              if (status == "assigned") {
                delta.assigned = 1;
              }
              if (status == "revise") {
                delta.revise = 1;
                delta.read = -1;
              }
              if (status == "final") {
                delta.final = 1;
                delta.revise = -1;
              }
              return {
                ...elem,
                radiologist: {
                  ...elem.radiologist,
                  assigned: elem.radiologist.assigned + delta.assigned,
                  read: elem.radiologist.read + delta.read,
                  revise: elem.radiologist.revise + delta.revise,
                  final: elem.radiologist.final + delta.final,
                },
              };
            })
            .sort((a, b) => a.radiologist.final - b.radiologist.final),
        );
      }
    });
    socket.on("radio:availability", () => {
      if (isSubAdmin || isSuperAdmin) {
        fetchRadioMetrics();
      }
    });
    return () => {
      socket.off("radio:status");
      socket.off("radio:availability");
    };
  }, []);
  // const formatAvailability = (availability) => {
  //   if (!availability || availability.length === 0) {
  //     return <Tag color="default">Not Available</Tag>;
  //   }

  //   return availability.map((slot, index) => {
  //     const startDate = dayjs(slot.start_date).format("DD MMM");
  //     const startTime = slot.start_time.substring(0, 5); // HH:MM
  //     const endDate = dayjs(slot.end_date).format("DD MMM");
  //     const endTime = slot.end_time.substring(0, 5); // HH:MM

  //     // Determine color based on status
  //     const getStatusColor = (status) => {
  //       switch (status?.toLowerCase()) {
  //         case "booked":
  //           return "green";
  //         case "available":
  //           return "blue";
  //         case "unavailable":
  //           return "red";
  //         default:
  //           return "default";
  //       }
  //     };

  //     return (
  //       <Tag
  //         key={index}
  //         color={getStatusColor(slot.status)}
  //         style={{ marginBottom: "4px" }}
  //       >
  //         {startDate} {startTime} - {endDate} {endTime}
  //       </Tag>
  //     );
  //   });
  // };

  // const totals = useMemo(() => {
  //   if (!radioMetrics || radioMetrics.length == 0) {
  //     return { totalAssigned: 0, totalRead: 0, totalRevise: 0, totalFinal: 0 };
  //   }

  //   return radioMetrics.reduce(
  //     (acc, item) => ({
  //       totalAssigned: acc.totalAssigned + (item.radiologist.assigned || 0),
  //       totalRead: acc.totalRead + (item.radiologist.read || 0),
  //       totalRevise: acc.totalRevise + (item.radiologist.revise || 0),
  //       totalFinal: acc.totalFinal + (item.radiologist.final || 0),
  //     }),
  //     { totalAssigned: 0, totalRead: 0, totalRevise: 0, totalFinal: 0 },
  //   );
  // }, [radioMetrics]);
  // const tableData = useMemo(() => {
  //   if (!radioMetrics || radioMetrics.length == 0) return [];
  //   return radioMetrics.map((item) => ({
  //     key: item.radiologist.id,
  //     name: item.radiologist.name,
  //     assigned: item.radiologist.assigned || 0,
  //     read: item.radiologist.read || 0,
  //     revise: item.radiologist.revise || 0,
  //     final: item.radiologist.final || 0,
  //     availability: item.availability,
  //   }));
  // }, [radioMetrics]);

  // Define columns for radiologist workload table
  // const radioColumns = [
  //   {
  //     title: "Radiologist Name",
  //     dataIndex: "name",
  //     key: "name",
  //     width: "25%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Assigned",
  //     dataIndex: "assigned",
  //     key: "assigned",
  //     align: "center",
  //     width: "10%",
  //   },
  //   {
  //     title: "Read",
  //     dataIndex: "read",
  //     key: "read",
  //     align: "center",
  //     width: "10%",
  //   },
  //   {
  //     title: "Revise",
  //     dataIndex: "revise",
  //     key: "revise",
  //     align: "center",
  //     width: "10%",
  //   },
  //   {
  //     title: "Final",
  //     dataIndex: "final",
  //     key: "final",
  //     align: "center",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Availability",
  //   //   dataIndex: "availability",
  //   //   key: "availability",
  //   //   width: "35%",
  //   //   render: (availability) => (
  //   //     <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
  //   //       {formatAvailability(availability)}
  //   //     </div>
  //   //   ),
  //   //   hidden: true,
  //   // },
  // ];
  const handleRadioSearch = (value) => {
    if (!value) {
      setRadioMetrics(allRadioMetrics);
      return;
    }

    setRadioMetrics(
      allRadioMetrics.filter((elem) =>
        elem?.radiologist?.name?.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };
  // Show radiologist summary only for subadmin and superadmin
  const showRadiologistSummary = isSubAdmin || isSuperAdmin;
  return (
    <>
      <DoctorHeader />
      <Sidebar />

      <div className="page-wrapper scrole_studies">
        <div className="content">
          <div className="tabel_area">
            <h2 className="studies_cus">Studies</h2>

            {!filterLoading && (
              <Form onFinish={onSearch} form={form}>
                <div className="row">
                  {/* Left Side - Filters */}
                  <div
                    className={showRadiologistSummary ? "col-lg-6" : "col-12"}
                  >
                    <div
                      style={{
                        background: showRadiologistSummary
                          ? "#f5f7fa"
                          : "transparent",
                        padding: showRadiologistSummary ? "20px" : "0",
                        borderRadius: showRadiologistSummary ? "8px" : "0",
                        height: "100%",
                      }}
                    >
                      {showRadiologistSummary && (
                        <h4 style={{ marginBottom: "20px", color: "#2c5282" }}>
                          Search Filters
                        </h4>
                      )}

                      {/* Grid Layout for Filters */}
                      <div className="row" style={{ marginBottom: "16px" }}>
                        {(isSubAdmin || isSuperAdmin) && (
                          <div
                            className={
                              showRadiologistSummary
                                ? "col-12"
                                : "col-lg-3 col-md-4 col-sm-6 col-12"
                            }
                          >
                            <FormItem
                              name="site"
                              style={{ marginBottom: "12px" }}
                            >
                              <Select showSearch placeholder="Filter Site">
                                <Option value="all">All</Option>
                                {siteData?.map((element) => (
                                  <Option
                                    key={element?.id}
                                    value={element?.name}
                                  >
                                    {element?.name}
                                  </Option>
                                ))}
                              </Select>
                            </FormItem>
                          </div>
                        )}

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="PatientName"
                              style={{ marginBottom: "12px" }}
                            >
                              <Input placeholder="Patient Name" />
                            </FormItem>
                          </div>
                        </div>

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="history_description"
                              style={{ marginBottom: "12px" }}
                            >
                              <Input placeholder="Study Description" />
                            </FormItem>
                          </div>
                        </div>

                        {(isSubAdmin || isSuperAdmin || isSitePerson) && (
                          <div
                            className={
                              showRadiologistSummary
                                ? "col-12"
                                : "col-lg-3 col-md-4 col-sm-6 col-12"
                            }
                          >
                            <div className="place_change">
                              <FormItem
                                name="refer_by"
                                style={{ marginBottom: "12px" }}
                              >
                                <Input placeholder="Refered By" />
                              </FormItem>
                            </div>
                          </div>
                        )}

                        {(isSubAdmin || isSuperAdmin) && (
                          <div
                            className={
                              showRadiologistSummary
                                ? "col-12"
                                : "col-lg-3 col-md-4 col-sm-6 col-12"
                            }
                          >
                            <div className="place_change">
                              <FormItem
                                name="category"
                                style={{ marginBottom: "12px" }}
                              >
                                <Select showSearch placeholder="Category">
                                  <Option value="">All</Option>
                                  {categories?.map((element) => (
                                    <Option
                                      key={element?.id}
                                      value={element?.id}
                                    >
                                      {element?.name}
                                    </Option>
                                  ))}
                                </Select>
                              </FormItem>
                            </div>
                          </div>
                        )}

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="modality"
                              style={{ marginBottom: "12px" }}
                            >
                              <Select
                                placeholder="Modality"
                                optionFilterProp="label"
                                options={[
                                  { value: "", label: "All" },
                                  { value: "XRAY", label: "XRay" },
                                  { value: "CT", label: "CT" },
                                  { value: "MR", label: "MR" },
                                ]}
                              />
                            </FormItem>
                          </div>
                        </div>

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="status"
                              style={{ marginBottom: "12px" }}
                            >
                              <Select
                                placeholder="Status"
                                optionFilterProp="label"
                                options={
                                  isSitePerson
                                    ? [
                                        { value: "", label: "All" },
                                        { value: "unread", label: "Unread" },
                                        { value: "final", label: "Final" },
                                      ]
                                    : [
                                        { value: "", label: "All" },
                                        { value: "unread", label: "Unread" },
                                        { value: "read", label: "Pending" },
                                        { value: "revise", label: "Revise" },
                                        { value: "final", label: "Final" },
                                      ]
                                }
                              />
                            </FormItem>
                          </div>
                        </div>

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="exam_date_time"
                              style={{ marginBottom: "12px" }}
                            >
                              <DatePicker
                                placeholder="Exam Date"
                                style={{ width: "100%" }}
                              />
                            </FormItem>
                          </div>
                        </div>

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="from_date"
                              style={{ marginBottom: "12px" }}
                            >
                              <DatePicker
                                placeholder="From"
                                style={{ width: "100%" }}
                              />
                            </FormItem>
                          </div>
                        </div>

                        <div
                          className={
                            showRadiologistSummary
                              ? "col-12"
                              : "col-lg-3 col-md-4 col-sm-6 col-12"
                          }
                        >
                          <div className="place_change">
                            <FormItem
                              name="to_date"
                              style={{ marginBottom: "12px" }}
                            >
                              <DatePicker
                                placeholder="To"
                                style={{ width: "100%" }}
                              />
                            </FormItem>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                          marginTop: "16px",
                        }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="button_searching"
                          style={{
                            marginBottom: showRadiologistSummary
                              ? "0px"
                              : "10px",
                          }}
                        >
                          Search
                        </Button>

                        <Button
                          onClick={() => {
                            handleResetSearch();
                            setExcelFilters("");
                          }}
                          style={{
                            marginBottom: showRadiologistSummary
                              ? "0px"
                              : "10px",
                          }}
                          className="primary"
                        >
                          Reset
                        </Button>

                        {isSuperAdmin && (
                          <Button
                            loading={isLoadingExcel}
                            style={{
                              fontSize: "medium",
                              display: "flex",
                              alignItems: "center",
                              background: "#016fb9",
                              color: "white",
                              marginLeft: "5px",
                              padding: "10px 5px!important",
                              marginBottom: showRadiologistSummary
                                ? "0px"
                                : "10px",
                            }}
                            className="primary studies_expert manu_ble"
                            onClick={() => {
                              handleExcelDownload();
                            }}
                          >
                            Export
                            <div style={{ padding: "0px 2px" }}>
                              <img
                                height={"20px"}
                                width={"20px"}
                                src={excelicon}
                                alt="Excel"
                              />
                            </div>
                          </Button>
                        )}

                        {userID != 336 && (
                          <div style={{ marginLeft: "5px" }}>
                            <Button
                              type="dashed"
                              onClick={startTimer}
                              // disabled={isRunning} // Disable button while timer is running
                            >
                              {isRunning ? (
                                <span style={{ color: "black" }}>
                                  {timeLeft} seconds left
                                </span>
                              ) : (
                                <Refresh />
                              )}
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Radiologist Workload Summary */}
                  {showRadiologistSummary && (
                    <div
                      className="col-lg-6"
                      style={{ maxHeight: "60vh", overflow: "auto" }}
                    >
                      <div
                        style={{
                          background: "#f5f7fa",
                          padding: "20px",
                          borderRadius: "8px",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "20px",
                            alignItems: "Center",
                          }}
                        >
                          <h4
                            style={{
                              marginBottom: "20px",
                              color: "#2c5282",
                            }}
                          >
                            Radiologist Workload Summary{" "}
                            <span
                              style={{ marginBottom: "20px", color: "#68a0e4" }}
                            >
                              Today
                            </span>
                          </h4>

                          <Input
                            placeholder="Search Radio here"
                            allowClear
                            onChange={(e) => handleRadioSearch(e.target.value)}
                            style={{ width: 200, marginBottom: "20px" }}
                          />
                        </div>
                        <div
                          style={{ flex: 1, minHeight: 0, overflow: "auto" }}
                        >
                          <div className="radiologist-metrics">
                            {radioMetrics.map((radio) => {
                              return (
                                <div
                                  key={radio.radiologist.id}
                                  className="radiologist-row"
                                >
                                  <div className="radiologist-name">
                                    {radio.radiologist.name}
                                    <h6 style={{ color: "#ccc0c0" }}>
                                      Total final cases :{" "}
                                      {radio?.radiologist?.final || 0}
                                    </h6>
                                  </div>

                                  <div
                                    className={`radiologist-count ${
                                      radio?.radiologist?.final <= 2
                                        ? "green"
                                        : radio?.radiologist?.final <= 5
                                          ? "yellow"
                                          : radio?.radiologist?.final <= 8
                                            ? "orange"
                                            : "red"
                                    }`}
                                  >
                                    {radio?.radiologist?.final}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Form>
            )}

            {isSitePerson && (
              <div className="d-flex justify-content-between mb-3">
                <Button
                  style={{
                    background: "#016FB9",
                    color: "white",
                    fontSize: "14px",
                  }}
                  type="primary"
                  onClick={showUploadModal}
                >
                  Upload Study
                </Button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
            )}

            <div style={{}}>
              <Table
                className="studyTable tablemain_auto study_table_border"
                columns={columns}
                // size="small"
                bordered
                loading={loading}
                pagination={{
                  total: StudyData.total,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  onChange: (page) => {
                    // (psetCurrentPageage);
                    console.log("changeing page--->", page);
                    currentPage.current = page;
                    setToggleStudies(!toggleStudies);
                  },
                  showSizeChanger: true,
                  onShowSizeChange: (current, size) => {
                    limit.current = size;
                    setToggleStudies(!toggleStudies);
                  },
                  showQuickJumper: true,
                }}
                dataSource={StudyData}
                rowKey={(record) => record?.study_details?.ID}
              />
            </div>
          </div>
          <Modal
            className="ModalFooterHide uploadstudy_modal"
            title="Upload Study"
            open={uploadModal.isModalOpen}
            onOk={handleOkStudyModal}
            onCancel={handleCancelStudyModal}
            maskClosable={false}
            destroyOnClose
          >
            <UploadStudyModal onCancel={handleCancelStudyModal} />
          </Modal>
        </div>
      </div>
      <Modal
        title="History"
        className="ModalFooterHide"
        open={textModal.isModalOpen}
        onOk={handleOkTextModal}
        onCancel={handleCancelTextModal}
        destroyOnClose
        width={450}
      >
        <StudyTextModal
          studyPrimaryKey={studyPrimaryKey}
          handleOk={handleOkTextModal}
          fetchData={getStudies}
        />
      </Modal>
      <Modal
        title="View Documents"
        className="ModalFooterHide"
        open={attachModal.isModalOpen}
        onCancel={handleCancelAttachModal}
        footer={null} // Remove default footer buttons
        destroyOnClose
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {attachModal?.image?.map((e, index) => (
            <div
              key={e}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>Document {index + 1}</div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Tooltip title="Preview" placement="left">
                  <Button
                    onClick={() => {
                      // if (!isDocUrl(e)) {
                      //   setImageModal({ isModalOpen: true, url: e });
                      //   handleCancelAttachModal();
                      // } else {
                      //   const link = document.createElement("a");
                      //   link.href = e;
                      //   link.download = true;
                      //   document.body.appendChild(link);
                      //   link.click();
                      //   document.body.removeChild(link);
                      // }

                      if (isPreviewable(e)) {
                        const previewFiles =
                          attachModal.image.filter(isPreviewable);
                        const index = previewFiles.findIndex((x) => x === e);

                        setPreviewModal({
                          open: true,
                          currentIndex: index,
                          files: previewFiles,
                        });

                        handleCancelAttachModal();
                      } else {
                        // Docs → download
                        const link = document.createElement("a");
                        link.href = e;
                        link.download = true;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }
                    }}
                  >
                    <EyeOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="Download" placement="right">
                  <Button
                    key={index}
                    icon={<DownloadOutlined />}
                    onClick={() => handleFileDownload(e)} // Remove file from the list
                  />
                </Tooltip>
                <Tooltip title="Delete" placement="right">
                  <Button
                    key={index}
                    icon={<DeleteOutlined />}
                    onClick={() => handleFileDelete(e)} // Remove file from the list
                    danger
                  />
                </Tooltip>
              </div>
            </div>
          ))}
        </div>

        {/* Upload media button */}
        <div style={{ marginTop: "10px" }}>
          <Upload
            action="/upload" // Your API endpoint for file upload
            listType="picture"
            showUploadList={false} // Hide the default upload list
            onChange={handleFileUploadChange} // Handle file selection/upload change
            fileList={uploadedFiles} // 🔧 Make it a controlled component
            onRemove={handleFileRemove} // 🔧 Handle removal from within Upload
            beforeUpload={() => false} //
            multiple
          >
            <Button icon={<UploadOutlined />}>Upload Media</Button>
          </Upload>
        </div>

        {/* Display the uploaded files */}
        <div style={{ marginTop: "10px" }}>
          <List
            bordered
            dataSource={uploadedFiles}
            renderItem={(file) => (
              <List.Item
                actions={[
                  <Button
                    key={file}
                    icon={<DeleteOutlined />}
                    onClick={() => handleFileRemove(file)} // Remove file from the list
                  />,
                ]}
              >
                <Space>
                  <span>{file.name}</span>
                </Space>
              </List.Item>
            )}
          />
        </div>

        {/* Submit button to send data */}
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </Modal>

      {/* Modal for image preview */}
      <Modal
        title="View Document"
        style={{
          height: "100%",
          width: "100%",
          maxWidth: "400px",
          minWidth: "100%",
          minHeight: "100%",
          maxHeight: "100%",
          top: "0",
          margin: "0",
        }}
        open={imageModal?.isModalOpen}
        onCancel={handleCloseImageModal}
        footer={null}
      >
        {isImageUrl(imageModal?.url) ? (
          <div className="d-flex justify-content-center">
            <Image
              src={imageModal?.url}
              preview={true}
              alt="Document"
              style={{ width: "100%", maxWidth: "400px", height: "80vh" }}
            />
          </div>
        ) : (
          <iframe
            src={imageModal?.url}
            width="100%"
            height="100%"
            title="Document"
            style={{ height: "80vh", maxWidth: "400px" }}
          />
        )}
      </Modal>
      <Modal
        open={previewModal.open}
        footer={null}
        width="85%"
        centered
        onCancel={() =>
          setPreviewModal({ open: false, currentIndex: 0, files: [] })
        }
        bodyStyle={{
          padding: 0,
          background: "#000",
        }}
      >
        <Carousel
          ref={(ref) => (carouselRef = ref)}
          initialSlide={previewModal.currentIndex}
          dots={false}
        >
          {previewModal.files.map((url, index) => (
            <div key={index}>
              <div
                style={{
                  height: "80vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#000",
                }}
              >
                {isImage(url) && (
                  <Image
                    src={url}
                    alt="preview"
                    preview={true}
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                )}

                {isPdf(url) && (
                  <iframe
                    src={url}
                    title="PDF Preview"
                    style={{
                      width: "80%",
                      height: "100%",
                      border: "none",
                      background: "#fff",
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </Carousel>

        {/* LEFT BUTTON */}
        <Button
          shape="circle"
          size="large"
          style={{
            position: "absolute",
            left: 20,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
          }}
          onClick={() => carouselRef?.prev()}
        >
          ‹
        </Button>

        {/* RIGHT BUTTON */}
        <Button
          shape="circle"
          size="large"
          style={{
            position: "absolute",
            right: 20,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
          }}
          onClick={() => carouselRef?.next()}
        >
          ›
        </Button>
      </Modal>

      {/* Modal for image preview */}
      <Modal
        title="View Document"
        style={{
          height: "100%",
          width: "100%",
          maxWidth: "400px",
          minWidth: "100%",
          minHeight: "100%",
          maxHeight: "100%",
          top: "0",
          margin: "0",
        }}
        open={imageModal?.isModalOpen}
        onCancel={handleCloseImageModal}
        footer={null}
      >
        <div className="d-flex flex-column align-items-center">
          {isImageUrl(imageModal?.url) ? (
            <Image
              src={imageModal?.url}
              alt="Document"
              style={{
                width: "100%",
                maxWidth: "400px",
                height: "80vh",
                objectFit: "contain",
              }}
              preview={true}
            />
          ) : (
            <iframe
              src={imageModal?.url}
              width="100%"
              height="100%"
              title="Document"
              style={{ height: "80vh", maxWidth: "400px" }}
            />
          )}

          {/* ✅ Download button shown for both image and document */}
          <Button
            type="primary"
            onClick={() => handleDownload(imageModal?.url)}
            style={{ marginTop: 16 }}
          >
            Download Document
          </Button>
        </div>
      </Modal>

      <Modal
        classNames="mb-5"
        style={{ left: 0, top: -100 }}
        title={
          <div>
            <span className="pe-2">
              {RadioPrefModal.type === "assign"
                ? "Assign Study to Radiologist"
                : "View Booked Slots"}
            </span>

            {studyStatus == "unread" && isEmergency == 1 && (
              <button type="text" className="btn btn-danger">
                Emergency
              </button>
            )}

            {studyStatus != "unread" && studyFlagEmergency == 1 && (
              <button type="text" className="btn btn-danger">
                Emergency
              </button>
            )}
          </div>
        }
        className="ModalFooterHide"
        open={RadioPrefModal.isModalOpen}
        onOk={handleOkPrefModal}
        onCancel={handleCancelPrefModal}
        width={810}
        height={400}
        destroyOnClose
        maskClosable={false}
        centered
      >
        <RadioPrefrenceModal
          preferenceData={StudyData}
          studyID={currentStudyID}
          studyPrimaryKey={studyPrimaryKey}
          handleOk={handleCancelPrefModal}
          type={RadioPrefModal.type}
          fetchData={getStudies}
          isEmergency={isEmergency}
        />
      </Modal>
      <Modal
        title="Assign Quality Checker"
        className="ModalFooterHide"
        open={qcModal.isModalOpen}
        onOk={handleOkQCModal}
        onCancel={handleCancelQCModal}
        destroyOnClose
        width={600}
        maskClosable={false}
        centered
      >
        <AssignQualityChecker
          studyPrimaryKey={studyPrimaryKey}
          handleOk={handleOkQCModal}
          fetchData={getStudies}
        />
      </Modal>
      <Modal
        title={
          gradeModal.grade
            ? "Assign Grade"
            : gradeModal.status === "revise"
              ? "Add Revise Reason"
              : "Give Feedback"
        }
        open={gradeModal.isModalOpen}
        destroyOnClose
        maskClosable={false}
        width={550}
        onCancel={() =>
          setGradeModal({
            radiologist: {},
            study_info_model_id: "",
            isModalOpen: false,
          })
        }
        footer={null}
      >
        <AssignGrade
          allGrades={allGrades}
          sendQCResponse={sendQCResponse}
          setGradeModal={setGradeModal}
          gradeModal={gradeModal}
          radiologist={gradeModal?.radiologist}
          study_info_model_id={gradeModal?.study_info_model_id}
          status={gradeModal?.status}
        />
      </Modal>

      <Modal
        title={feedbackData.length ? "Revise Reason" : "No Revise Reason"}
        className="ModalFooterHide"
        open={FeedbackModal.isModalOpen}
        onOk={handleOkFeedbackModal}
        onCancel={handleCancelFeedbackModal}
        destroyOnClose
        maskClosable={false}
        width={450}
      >
        <StudyFeedbackModal feedbackData={feedbackData} />
      </Modal>

      <Modal
        title={
          remarksData?.GradeAssigned?.data?.length ? "Remark" : "No Remark"
        }
        className="ModalFooterHide"
        open={remarkModal.isModalOpen}
        onOk={handleOkRemarkModal}
        onCancel={handleCancelRemarkModal}
        destroyOnClose
        maskClosable={false}
        width={450}
      >
        <StudyRemarkModal remarksData={remarksData} />
      </Modal>

      <Modal
        title="Edit Study Description"
        className="ModalFooterHide"
        open={editDescModal.isModalOpen}
        onOk={handleOkEditDescModal}
        onCancel={handleCancelEditDescModal}
        destroyOnClose
        maskClosable={false}
        width={450}
      >
        <UpdateStudyDescription
          studyDesc={studyDesc}
          studyPrimaryKey={studyPrimaryKey}
          handleOk={handleOkEditDescModal}
          fetchData={getStudies}
        />
      </Modal>

      <Modal
        title="Edit Radiologist Prefrence"
        className="ModalFooterHide"
        open={editRadioModal.isModalOpen}
        onOk={handleOkEditRadioModal}
        onCancel={handleCancelEditRadioModal}
        destroyOnClose
        maskClosable={false}
        width={550}
      >
        <ManageStudyPreference
          studyId={studyPrimaryKey}
          handleOk={handleOk}
          fetchData={getStudies}
          isEmergency={isEmergency}
          studyStatus={studyStatus}
        />
      </Modal>
      {/* <Modal
        title="Study Viewer"
        className="ModalFooterHide"
        open={editViewerRadioModal.isModalOpen}
        onOk={handleOkViewerEditRadioModal}
        onCancel={handleCancelViewerEditRadioModal}
        destroyOnClose
        maskClosable={false}
        width={900} // Adjust width as needed
      >
        <iframe
          src={editRadioModal.iframeUrl}
          width="100%"
          height="500px"
          style={{ display: "flex", justifyContent: "center" }} // Adjust height as needed
          frameBorder="0"
          title="Study Viewer"
        />
      </Modal> */}
    </>
  );
}

export default Studies;
